<template>
  <div class="book-element-list" ref="audiolist" tabindex="0" @focus="focus" @keyup.enter="keyup">
    <div class="page" :tabindex="tabIndex" @focus="focusInner" @keyup.enter="keyUpInner" v-for="(page, index) in attachments" :key="index" :ref="`page${page.pageNumber}`">
    <a href="#" :tabindex="subTabIndex" class="page-link" :title="`Gå til side ${page.pageNumber}`" @click.prevent="goToPage(page.pageNumber)">Side {{ page.pageNumber }}</a>
      <ul role="group">
        <AudioListItem :tabindex="subTabIndex" v-for="(attachment, attachmentIndex) in page.attachments" :attachment="attachment" :page-number="page.pageNumber" :key="attachmentIndex">
        </AudioListItem>
      </ul>
    </div>
  </div>
</template>

<script>
import AudioListItem from './AudioListItem'
import bookTools from '@/utils/book'

export default {
  data () {
    return {
      active: false,
      click: false,
      tabIndex: -1,
      subTabIndex: -1
    }
  },
  activated () {
    this.scrollToActive()
    this.active = true
  },
  deactivated () {
    this.active = false
  },
  methods: {
    scrollToActive () {
      let pageNumber = this.pageNumber
      if (!bookTools.isEven(pageNumber)) {
        pageNumber = pageNumber - 1
      }
      var closestPageNumber = bookTools.closestNumber(pageNumber, this.attachments.map(a => a.pageNumber))

      if (closestPageNumber) {
        var el = (this.$refs[`page${closestPageNumber}`] || [])[0]
        if (el !== null || el !== undefined) {
          var parentEl = this.$refs.audiolist.parentElement.parentElement
          parentEl.scrollTop = el.offsetTop
          if (parentEl.scrollTop === el.offsetTop) {
            parentEl.scrollTop -= 40
          }
        }
      }
    },
    goToPage (pageNumber) {
      this.click = true
      this.$router.push({name: 'Page', params: { pageNumber: pageNumber }})
    },
    keyup (event) {
      this.tabIndex = 0
    },
    keyUpInner (event) {
      this.subTabIndex = 0
    },
    focus (event) {
      this.tabIndex = -1
    },
    focusInner (event) {
      this.subTabIndex = -1
    }
  },
  computed: {
    attachments () {
      return this.$store.getters.attachments.map(a => {
        return {
          ...a,
          _showPlayer: false
        }
      })
    },
    pageNumber () {
      return this.$route.params.pageNumber
    }
  },
  watch: {
    '$store.getters.leftMenuOpen' (newVal) {
      if (newVal && this.active) {
        this.scrollToActive()
      }
    },
    pageNumber () {
      if (this.active && !this.click) {
        setTimeout(() => {
          this.scrollToActive()
        }, 100)
      }

      this.click = false
    }
  },
  components: {
    AudioListItem
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/misc/AudioList.vue